import { createClient, type SupabaseClient } from '@supabase/supabase-js';

// We keep the singleton nullable so the offline-only Dexie path keeps working
// when the env vars are absent (e.g. forks, CI without secrets). Callers must
// check `isSupabaseConfigured()` before reaching for `.auth` / `.from`.
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

function buildClient(): SupabaseClient | null {
  if (!url || !anonKey) return null;
  return createClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
}

export const supabase: SupabaseClient | null = buildClient();

export function isSupabaseConfigured(): boolean {
  return supabase !== null;
}
